// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  AM_URL: 'https://legacy.test.scram.awsplatform.lgnet.co.uk',//'https://test.id.awsplatform.landg.com',//'$AM_URL',
  REALM_PATH: 'bravo',//'$REALM_PATH',
  WEB_OAUTH_CLIENT: 'dcj-frontend',//'$WEB_OAUTH_CLIENT',
  JOURNEY_LOGIN: 'login',//'$JOURNEY_LOGIN',
  API_URL: 'http://localhost:4200/eap/dcj/home/after-login',//'$API_URL',
  production: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
